import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CurrentLanguage from '@/components/CurrentLanguage.vue';
import { Co2CountryAverage } from '@/models/co2-quiz.model';
import { useEvents, Event } from '@/services/events.composable';
import { Actions, Mutations, ShiftCMSState } from '@/store';
import { NEW_ID } from '@/util/constants';
import { computed, onMounted, PropType, ref, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import {
  Co2QuizStoreActions,
  Co2QuizStoreState,
} from '@/stores/co2-quiz.store';
import { countries, OneEarth } from '@/models/country.model';
import CategoryField from '@/components/categories/CategoryField.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Co2AverageForm',
  props: {
  data: {
    type: Object as PropType<Co2CountryAverage>,
  },
},
  setup(__props) {

const store = useStore<ShiftCMSState & { co2: Co2QuizStoreState }>();
const events = useEvents();

const props = __props;

const valid = ref<boolean>(false);

const value = ref<Co2CountryAverage>({
  id: NEW_ID,
  value: 0,
  country: 'NL',
  category: null as any, // eslint-disable-line @typescript-eslint/no-explicit-any
  ...(props.data || {}),
});

const action = computed<string>(() =>
  value.value.id === NEW_ID ? 'Add' : 'Save',
);

const saveCo2CountryAverage = async () => {
  let success: boolean = false;
  if (valid.value) {
    if (value.value.id === NEW_ID) {
      success = await store.dispatch(
        Co2QuizStoreActions.AddCo2Average,
        value.value,
      );
    } else {
      success = await store.dispatch(
        Co2QuizStoreActions.UpdateCo2Average,
        value.value,
      );
    }
  }
  if (success) {
    events.emit(Event.Saved, true);
    store.dispatch(Actions.ShowNotification, {
      message: 'Saved value',
      type: 'success',
    });
    store.commit(Mutations.HideDrawer);
    store.dispatch(Co2QuizStoreActions.GetCo2Averages);
  }
};

const updateLanguage = async () => {
  if (value.value.id === NEW_ID) {
    Object.assign(value.value, { title: '', type: 'value' });
  } else {
    const q = await store.dispatch(
      Co2QuizStoreActions.GetCo2Value,
      value.value.id,
    );

    if (q) {
      Object.assign(value.value, { ...q });
    }
  }
};

onMounted(() => {
  events.on(Event.LanguageChanged, updateLanguage);
  if (props.data) {
    Object.assign(value.value, props.data);
  }
});

onBeforeUnmount(() => {
  events.off(Event.LanguageChanged, updateLanguage);
});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    modelValue: valid.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((valid).value = $event)),
    onSubmit: _withModifiers(saveCo2CountryAverage, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, [
            _createTextVNode(_toDisplayString(_ctx.$t(action.value)) + " a value ", 1),
            _createVNode(CurrentLanguage)
          ]),
          _createVNode(CategoryField, {
            class: "mt-8",
            modelValue: value.value.category,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value.value.category) = $event)),
            max: 1
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_text_field, {
            modelValue: value.value.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value.value.value) = $event)),
            label: "Value",
            required: ""
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_autocomplete, {
            modelValue: value.value.country,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((value.value.country) = $event)),
            items: [{ text: 'One Earth', value: _unref(OneEarth) }, ..._unref(countries)],
            class: "mb-8",
            label: "Country",
            "item-title": "text",
            "item-value": "value",
            "hide-details": true
          }, null, 8, ["modelValue", "items"]),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { col: "2" }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "reset",
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createTextVNode("Reset")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "submit",
                    color: "success",
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(action.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { col: "2" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})